namespace advisorop.components.advisor {

    export class AccountMappingController {

        $router;
        boAccount: domains.IBOUnmappedAccount;
        account: domains.IAccount = { id: 0, investors: [], manualAccount: {} };
        
        // statuses for ladda ...
        updatingAccountLadda: boolean = false;
        cuAccount: CuAccountController;

        // static $inject = ["advisorService", "generalService"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService) {
        }
        
        openAccount(): ng.IPromise<void> {            
            //open account ...
            this.cuAccount.bindAccountFromForm();

            if (!this.cuAccount.validateAccountBasicInformationForm())
                return null;

            this.account.titleId = 0;//this.title.id;
            this.account.titleName = "";//this.title.name;
            this.account.usdMarketValue = 0;
            this.account.status = 0;
            this.account.id = 0;

            const acc = angular.copy(this.account);
            acc.advisoryFirm = null;
            for (var ind = 0; ind < acc.investors.length; ind++) {
                acc.investors[ind].systemLogin = null;
                acc.investors[ind].companyGroup = null;
            }

            // console.log(`Acc:`, acc);

            this.updatingAccountLadda = true;

            return this.advisorService.openAccount(acc)
                .then((data) => {

                    toastr.success("Account has been successfully mapped.");

                    this.account = data.data;

                    this.$router.navigate(['NewAccount', { accountId: this.account.id }]);
                })
                .finally(() => {
                    this.updatingAccountLadda = false;
                });
        };
        
        loadBOAccount(boAccountId: number): void {

            //console.log(`Loading data for UNMAPPED account ${boAccountId}`);

            this.advisorService.getUnmappedAccount(boAccountId)
                .then(response => {
                   
                    this.boAccount = response.data;

                    //console.log("BO account data loaded...", this.boAccount);

                    ////this.account.ppAccountId = this.ppAccount.id;
                    //this.account.number = this.boAccount.accountNumber;
                    //this.account.name = this.boAccount.accountName;
                    //this.account.titleName = this.boAccount.accountName;
                    //this.account.custodianId = +this.boAccount.custodianId;
                    //if (this.boAccount.accountType === "INDV") {
                    //    this.account.accountType = domains.InvestmentType.INDIVIDUAL_HOLDINGS;
                    //    this.cuAccount.selAccountType = <domains.ILOV>{ value: domains.InvestmentType.INDIVIDUAL_HOLDINGS };
                    //}

                    //this.advisorService.getAdvisoryFirmsForAdvisor()
                    //.then(response => {
                    //    //var boFirms = response.data.filter(v => v.boFirmId == this.boAccount.firmId);
                    //    var boFirms = [];
                    //    if (boFirms.length > 0) {
                    //        this.account.advisoryFirmId = boFirms[0].id;
                    //        this.cuAccount.bindAccountForm();
                    //        //this.account.advisoryFirm = ppFirms[0];
                    //        //this.cuAccount.selAdvisoryFirm = ppFirms[0];
                    //    }

                    //}, err => this.generalService.showError(err));
                    
                }, err => this.generalService.showError(err));

            //console.log(`Mapping BoAccount to Account...`);
            this.advisorService.getMapUnmappedAccount(boAccountId)
                .then(response => {
                    //console.log(`Mapping result: `, response.data);
                    this.account = response.data;
                    this.cuAccount.bindAccountForm2(response.data);
                }, err => this.generalService.showError(err));
        };

        bindCuAccount(ctrl: CuAccountController) {
            this.cuAccount = ctrl;
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            if (next.params.accountId) {
                this.loadBOAccount(<number>next.params.accountId);
            }
        }
        
    }
    
    class AccountMapping implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        $canActivate;

        constructor() {
            this.bindings = {      
                "$router": "<"
            };
            this.controller = ["advisorService", "generalService", AccountMappingController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/account-mapping.html';
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable account mapping");
                    return false;
                }
                return true;
            }];
        }
    }
    angular.module(Constants.APP).component("accountMapping", new AccountMapping());

}